<br>
<br>
<br>
<br>
<br>
<br>
<br>
<br>


<div class="container">
  <div class="row">
    <div class="col-12">
      <p class="text-white-50">{{ title }}</p>
      <br>
      <div class="my-1">
        <button class="btn btl-rounded btn-primary" type="button" [routerLink]="['/catfichainmaterial/form']">Crear Ficha Inmaterial</button>
    </div>
      <table class="table table-responsive table-striped table-bordered table-light table-sm table-hover">
        <thead>
          <tr>
            <th>id</th>
            <th>Nombre Representante</th>
            <th>Tipo de Menifestación</th>
            <th>Ubic. Manifestación</th>
            <th>Cod.Reg.</th>
            <th>Editar</th>
            <th>Eliminar</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ficha of catFichasInmateriales">
            <td>{{ ficha.id }}</td>
            <td>{{ficha.nombre_representante}}</td>
            <td>{{ ficha.nombre_manifestacion }}</td>
            <td>{{ficha.ubicacion_manifestacion}}</td>
            <td>{{ficha.codregistro}}</td>
            <td>
              <a routerLink='/catfichainmaterial/form/{{ ficha.id }}' class="btn btn-warning btn-sm">Editar</a>
              
            </td>
            <td><a (click)="delete(ficha)" class="btn btn-danger btn-sm">Eliminar</a></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>